import { getElementUniqueId, AutocompleteValidationChain, getCurrentRouteInfo, isErpElInputAutoComplate, isErpElSelectRemote, getErpElSelectRemoteVm, isInputActive } from './utils'
import { isAutocomplateInput, isOpenAutocomplate, routeAutocompleteStatus, checkInputStatus } from './input-check'
import { AutoCompleteStore } from './store'
import { showPopover, hidePopover, setPopoverData } from './popover'
import { getAutocompleteDomConfig } from './autocomplete-dom'

export class AutoComplete {
  constructor(options) {
    this.options = options
    this.autoCompleteStore = new AutoCompleteStore()
    this.autocompleteValidationChain = new AutocompleteValidationChain()
    this._globalFocus = this.globalFocus.bind(this)
    this._handleInputBlur = this.handleInputBlur.bind(this)
    this._handleInputInput = this.handleInputInput.bind(this)
    this.init()
  }

  /**
  * 检查是否是需要支持Autocomplate的输入框
  * @param {Element}
  * @return {Boolean}
  */
  isAutocomplateInput(el) {
    return this.autocompleteValidationChain.executeValidations(el, this.options)
  }

  saveKeywords(el, value) {
    if (value) {
      const { id } = getElementUniqueId(el)
      const { meta = {} } = getCurrentRouteInfo(el)
      const autocompleteDomConfig = getAutocompleteDomConfig(el)
      this.autoCompleteStore.updateHistoryKeywords(id, value, {
        ...meta,
        ...autocompleteDomConfig,
        inputAutocomplete: autocompleteDomConfig.inputAutocomplete || meta.inputAutocomplete,
        maxLength: autocompleteDomConfig.inputAutocompleteNumber || meta.inputAutocompleteNumber,
      })
    }
  }

  /**
  * 失焦、做关键词保存动作
  * @param {Element}
  */
  handleInputBlur(event) {
    const el = event.target
    el._erpInputAutoCompleteEvent = false
    let time = 0
    const value = el.value.trim()
    setTimeout(() => {
      if (value.split('，').length >= 3) return
      this.saveKeywords(el, value)
    }, time)
    hidePopover()
    this.removeInputEvent()
  }

  /**
  * 获焦处理、做关键词查询动作
  * @param {Element}
  */
  handleInputFocus(el, callBack) {
    const { id } = getElementUniqueId(el)
    if (!id) return
    this.autoCompleteStore.getHistoryKeywords(id).then(data => {
      if (data && data.historyKeywords && data.historyKeywords.length) {
        el && this.mountHistoryKeywords(el, data, id)
        typeof callBack === 'function' && callBack(el)
      }
    })
  }

  /**
  * 输入
  * @param {Element}
  */
  handleInputInput(event) {
    const { target } = event
    if (!target.value.trim()) {
      this.handleInputFocus(target, (el) => showPopover(el))
    } else {
      hidePopover()
    }
  }

  /**
  * 挂载输入框事件
  * @param {Element}
  */
  attachInputEvent(el) {
    el && el.addEventListener('blur', this._handleInputBlur)
    el && el.addEventListener('input', this._handleInputInput)
  }

  /**
  * 移除输入框事件
  * @param {Element}
  */
  removeInputEvent(el) {
    el && el.removeEventListener('blur', this._handleInputBlur)
    el && el.removeEventListener('input', this.handleInputInput)
  }
  /**
  * 派发input
  * @param {Element}
  */
  dispatchInputEvent(el, value) {
    if (el && value) {
      ['input', 'change', 'blur'].forEach(eventName => {
        const inputEvent = new Event(eventName)
        el.dispatchEvent(inputEvent, value)
      })
    }
  }

  /**
  * 挂载历史关键词组件
  * @param {Element}
  */
  mountHistoryKeywords(el, data = {}, inputId) {
    setTimeout(() => {
      if (!isInputActive() || el !== document.activeElement) return
      const { historyKeywords } = data
      const _data = JSON.parse(JSON.stringify(historyKeywords)) || []
      if (_data && _data.length) {
        setPopoverData(el, {
          ...data,
          historyKeywords: _data,
          historyKeywordClick: (data, index) => {
            const { value } = data
            if (!value) return
            el.value = value

            if (isErpElInputAutoComplate(el)) {
              const focusEvent = new Event('focus')
              el.dispatchEvent(focusEvent)
            }
            // select remote
            if (isErpElSelectRemote(el)) {
              el._erpInputAutoCompleteEvent = true
              const vm = getErpElSelectRemoteVm(el)
              if (vm) {
                vm.previousQuery = ''
                vm.visible = true
                vm.handleQueryChange(value)
                return
              }
            }
            // 派发事件
            this.dispatchInputEvent(el, value)
            // 热度更新
            if (index > 0) {
              this.autoCompleteStore.updateHistoryKeywordsIndex(inputId, index)
            }
            hidePopover()
          },
          historyKeywordDelete: (data) => {
            this.autoCompleteStore.deleteHistoryKeyword(inputId, data)
          },
          historyKeywordDeleteAll: () => {
            this.autoCompleteStore.deleteAllHistoryKeyword(inputId)
          }
        })
      }
    }, 20)
  }

  addFocusListener() {
    document.addEventListener('focus', this._globalFocus, true)
  }
  removeFocusListener() {
    document.removeEventListener('focus', this._globalFocus, true)
  }
  globalFocus(event) {
    // 防止聚焦后读取readonly等状态不能实时获取
    hidePopover()
    setTimeout(() => {
      const el = event.target
      if (el._erpInputAutoCompleteEvent) return
      if (el && this.isAutocomplateInput(el)) {
        // 特殊逻辑，el-autocomplate
        if (isErpElInputAutoComplate(el) && el.value) {
          return
        }
        // 特殊逻辑，el-select-remote
        if (isErpElSelectRemote(el)) {
          try {
            const vm = getErpElSelectRemoteVm(el)
            const formItemMenuIntance = vm.$parent.$parent.$parent
            if (formItemMenuIntance.item && formItemMenuIntance.item.options && formItemMenuIntance.item.options.length) {
              formItemMenuIntance.item.options = []
            }
            // el-select输入框有选择内容了
            setTimeout(() => {
              const multipleOptions = (Array.isArray(vm.selected) && vm.selected.length) || (vm.selected && vm.selected.value)
              // 默认有子级了就不显示
              const isElOption = vm.$slots.default && vm.$slots.default.length
              if (multipleOptions || isElOption) {
                hidePopover()
              }
            }, 100)
            if (vm.selected.length || (vm.selected && vm.selected.value)) {
              return
            }
          } catch (e) {
            console.error(e)
          }
        }

        this.attachInputEvent(el)
        this.handleInputFocus(el)
      }
    })
  }
  destroy() {
    this.removeFocusListener()
  }
  addCheckAutocomplateInputRule() {
    // 检查顺序从上往下 checkInputStatus -> isOpenAutocomplate
    [
      checkInputStatus,
      routeAutocompleteStatus,
      isAutocomplateInput,
      isOpenAutocomplate,
    ].forEach(fn => this.autocompleteValidationChain.addValidationFunction(fn))
  }
  init() {
    try {
      this.addCheckAutocomplateInputRule()
      this.addFocusListener()
    } catch (e) {
      console.error('ERP_ERROR: initAutoComplete', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/index.js